export var FieldDescriptionKind;
(function (FieldDescriptionKind) {
    FieldDescriptionKind[FieldDescriptionKind["SELECT"] = 0] = "SELECT";
    FieldDescriptionKind[FieldDescriptionKind["NUMBER"] = 1] = "NUMBER";
    FieldDescriptionKind[FieldDescriptionKind["STRING"] = 2] = "STRING";
    FieldDescriptionKind[FieldDescriptionKind["BOOLEAN"] = 3] = "BOOLEAN";
    FieldDescriptionKind[FieldDescriptionKind["STEP_REFERENCE"] = 4] = "STEP_REFERENCE";
    FieldDescriptionKind[FieldDescriptionKind["ENUM"] = 5] = "ENUM";
    FieldDescriptionKind[FieldDescriptionKind["BINARY_DATA"] = 6] = "BINARY_DATA";
})(FieldDescriptionKind || (FieldDescriptionKind = {}));
